module.exports = __webpack_public_path__ + "img/htal-priv-ntra-sra-de-la-merced.adcb721c.png";